export default {
  APARTMENTS_IN_CALL_SETTINGS: 'APARTMENTS_IN_CALL_SETTINGS',
  DORMAKABA: 'DORMAKABA',
  GUEST_ACCESS: 'GUEST_ACCESS',
  HEG_MAINTENANCE: 'HEG_MAINTENANCE',
  ORY_REGISTRATION: 'ORY_REGISTRATION',
  SITE_BLE: 'SITE_BLE',
  SURVICATE: 'SURVICATE',
  USER_BLE_CREDENTIAL: 'USER_BLE_CREDENTIAL',
};
